import { types } from "../types/types";

const initialState = {
  liquidez: {},
};

export const liquidezReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.getValuesLiquidez:
      return {
        ...state,
        liquidez: [...action.payload],
      };
    case types.authLogout:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};
